import { useMutation, useQueryClient } from "@tanstack/react-query";
import { client } from "$api/client";

export const useDelete = (url, setIsLoading) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      setIsLoading((isLoading) => ({ ...isLoading, delete: true }));
      return await client.delete(url, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries();
      setIsLoading((isLoading) => ({ ...isLoading, delete: false }));
    },
    onError: () => {
      queryClient.invalidateQueries();
      setIsLoading((isLoading) => ({ ...isLoading, delete: false }));
    },
  });
};
